"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var gatsby_link_4 = require("gatsby-link");
var React = require("react");
var HeaderMenu_2 = require("../components/HeaderMenu/HeaderMenu");
var SidebarMenu_1 = require("../components/SidebarMenu/SidebarMenu");
var semantic_ui_react_10 = require("semantic-ui-react");
require("../css/styles.css");
require("../css/responsive.css");
require("../css/semantic.min.css");
require("prismjs/themes/prism-okaidia.css");
exports.menuItems = [{ name: "Home", path: "/", exact: true, icon: "home", inverted: true }, { name: "About", path: "/about/", exact: true, icon: "info circle" }, { name: "Blog", path: "/blog/", exact: false, icon: "newspaper" }];

var DefaultLayout = function (_React$PureComponent) {
    _inherits(DefaultLayout, _React$PureComponent);

    function DefaultLayout() {
        _classCallCheck(this, DefaultLayout);

        return _possibleConstructorReturn(this, (DefaultLayout.__proto__ || Object.getPrototypeOf(DefaultLayout)).apply(this, arguments));
    }

    _createClass(DefaultLayout, [{
        key: "render",
        value: function render() {
            var pathname = this.props.location.pathname;

            var isHome = pathname === "/";
            return React.createElement(semantic_ui_react_10.Sidebar.Pushable, { as: semantic_ui_react_10.Segment }, React.createElement(SidebarMenu_1.default, { Link: gatsby_link_4.default, pathname: pathname, items: exports.menuItems, visible: false }), React.createElement(semantic_ui_react_10.Sidebar.Pusher, { style: { minHeight: "100vh" } }, isHome ? null : React.createElement(HeaderMenu_2.default, { Link: gatsby_link_4.default, pathname: pathname, items: exports.menuItems }), React.createElement("div", { style: { paddingBottom: 60 } }, this.props.children()), React.createElement(semantic_ui_react_10.Segment, { inverted: true, vertical: true, style: { position: "absolute", bottom: 0, width: "100%" } }, React.createElement(semantic_ui_react_10.Container, { textAlign: "center" }, React.createElement("p", null, "Powered with ", React.createElement(semantic_ui_react_10.Icon, { name: "heart" }), " by Gatsby 1.0")))));
        }
    }]);

    return DefaultLayout;
}(React.PureComponent);

exports.default = DefaultLayout;


// WEBPACK FOOTER //
// ./~/babel-loader/lib?{"presets":["babel-preset-env"],"plugins":["/opt/build/repo/~/gatsby/dist/utils/babel-plugin-extract-graphql.js"]}!./~/ts-loader!./src/layouts/index.tsx